import MuiStack from '@mui/material/Stack';
import React from 'react';

import { propsMapper } from '~/common/components/PropertyMappers/propsMapper';

type StackProps = React.ComponentProps<typeof MuiStack> & {
  component?: string;
};

const Stack = React.forwardRef<any, StackProps>(
  ({ children, ...props }, ref) => {
    const updatedProps = propsMapper(props);

    return (
      <MuiStack ref={ref} {...updatedProps}>
        {children}
      </MuiStack>
    );
  },
);

Stack.displayName = 'Stack';

export default Stack;
